import { VRadio } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRadio,_vm._g(_vm._b({staticClass:"w-radio--input"},'v-radio',{..._vm.$props, ..._vm.$attrs},false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }